module.exports = __webpack_public_path__ + "img/dianliu1.gif";